import { render } from "./ChartCriteriaResults.vue?vue&type=template&id=db04c840"
import script from "./ChartCriteriaResults.vue?vue&type=script&lang=js"
export * from "./ChartCriteriaResults.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__